module.exports = __webpack_public_path__ + "img/tech-left.66fecdf.webp";